import { PlayerAhoyEvent } from '../player_ahoy_event';
import { PlayerEnvironment } from '../player_environment';
import isFeatureToggleOn from "../utils/feature_toggle";
import { displayLabel } from './helper'

export default class Overlay {
  constructor(options = {}){
    this._tech = options.tech;
    this._data = options.data;
    this._showing = false;
    this._isGoogleTagDisplayCalled = false;
    this._container = null;
  }

  tech() {
    return this._tech;
  }
 
  data() {
    return this._data;
  }

  showing() {
    return this._showing;
  }

  container() {
    return this._container;
  }

  firstRenderTime() {
    return this.data().overlayFirstRenderTime() * 1000;
  }

  refreshInterval() {
    return this.data().overlayRefreshInterval() * 1000;
  }

  start() {
    if (!this.showing()) {
      this._showing = true;
      this.initOverlay();
    }
  }

  initOverlay() {
    if (this.shouldInitOverlay()) {
      this.setAhoyEventGlobalProperties();
      if(!this.container()) {
        this._container = this.createOverlayAdContainer();
        this.tech().el().appendChild(this.container());
      }
      this.triggerOverlayAd();
      this.appendCloseButton();
    }
  }

  shouldInitOverlay() {
    return this.data().overlayAdDomId() != "";
  }

  createOverlayAdContainer() {
    const container = document.createElement('div');
    container.id = 'overlayAdContainer'
    container.className = 'overlay-ad-container';
    container.style.visibility = "hidden";

    container.appendChild(this.createOverlayAd());

    return container;
  }

  createOverlayAd() {
    var overlayAd = document.createElement('div');
    overlayAd.id = this.data().overlayAdDomId();
    overlayAd.className = 'overlay-ad'
    return overlayAd;
  }

  triggerOverlayAd() {
    if (this.shouldTriggerOverlayAd()) {
      this._selfHideTimeout = setTimeout(() => {
        this.hide();
      }, 20000);

      if (this._isGoogleTagDisplayCalled) {
        window.googletag.cmd.push(this.refreshAd());
      } else {
        window.googletag.cmd.push(this.displayAd());
        this._isGoogleTagDisplayCalled = true;
      }
    } else {
      this._showing = false;
      this.retry();
    }
  }

  shouldTriggerOverlayAd() {
    if (
      !this.isEmbedAndPlayerWidthBelow300() &&
      this.isBannerAdForPremierUserToggledOnOrContentNotPremium() &&
      this.isGPTConfigured() &&
      this.isContainerInViewport()
    ) {
      return true;
    }

    return false;
  }

  showOverlayAd() {
    setTimeout(() => {
      this.container().style.visibility = "";
    }, 300);
    this.appendCloseButton();
  }

  isEmbedAndPlayerWidthBelow300() {
    return this.data().embed() === 'true' && this.tech().el().clientWidth() <= 300
  }

  isBannerAdForPremierUserToggledOnOrContentNotPremium() {
    return isFeatureToggleOn('enable_premier_user_banner_ads') || !this.data().isPremier()
  }

  isGPTConfigured() {
    if (window.googletag &&
        window.googletag.apiReady &&
        window.googletag.pubadsReady &&
        window.kmklabs &&
        window.kmklabs.gpt &&
        window.kmklabs.gpt.overlay_ad) {
      return true;
    }
    else {
      return false;
    }
  }

  isContainerInViewport() {
    var boundingRect = this.container().getBoundingClientRect();
    var elementAtBoundingRect = document.elementFromPoint((boundingRect.left + boundingRect.right) / 2, (boundingRect.top + boundingRect.bottom) / 2)

    if (
      document.visibilityState === "visible" &&
      (
        elementAtBoundingRect === this.tech().videoElement() ||
        elementAtBoundingRect === document.querySelector('.vjs-control-bar')
      )
    ) {
      return true;
    } else {
      return false;
    }
  }

  displayAd() {
    return function() {
      window.googletag.display(window.kmklabs.gpt.overlay_ad);
    }
  }

  refreshAd() {
    return function() {
      window.googletag.pubads().refresh([window.kmklabs.gpt.overlay_ad]);
    };
  }

  appendCloseButton() {
    setTimeout(() => {
      if (this.container()) {
        const overlayAd = this.container().querySelector('.overlay-ad')
        overlayAd.appendChild(this.closeButton());
      }
    }, 5000);
  }

  sendStartEvent(event) {
    this.sendEvent("START", event);
  }

  sendEmptyEvent(event) {
    this.sendEvent("EMPTY", event);
  }

  sendImpressionEvent(event) {
    this.sendEvent("IMPRESSION_VIEWABLE", event);
  }

  hide() {
    this._showing = false;
    clearTimeout(this._selfHideTimeout);

    this.container().style.visibility = "hidden";
    
    this.retry();
  }

  retry() {
    setTimeout(() => {
      this.start();
    }, this.refreshInterval());
  }

  onCloseButtonClick(e) {
    this.sendEvent("CLOSE");
    e.stopPropagation();
    this.hide();
  }

  closeButton() {
    if (typeof this._closeButton == "undefined") {
      const closeButton = document.createElement("a");
      closeButton.className = "overlay-ad-close";

      closeButton.onclick = this.onCloseButtonClick.bind(this);

      this._closeButton = closeButton;
    }
    return this._closeButton;
  }

  sendEvent(ad_event, props = {}) {
    PlayerAhoyEvent.sendPlaybackBannerAd({
      ad_uuid: props.ad_uuid,
      ad_slot: 'overlay',
      play_uuid: this.data().playUUID(),
      ad_event: ad_event,
      advertiser_id: props.advertiser_id,
      campaign_id: props.campaign_id,
      creative_id: props.creative_id,
      is_empty: props.is_empty,
      line_item_id: props.line_item_id,
      size: props.size,
      source_agnostic_creative_id: props.source_agnostic_creative_id,
      source_agnostic_line_Item_id: props.source_agnostic_line_Item_id
    });
  }

  setAhoyEventGlobalProperties() {
    let globalData = {
      page: PlayerEnvironment.locationHref(),
      videopremier: this.data().isPremier(),
      referrer: PlayerEnvironment.referrer(),
      is_preview: this.data().preview(),
      cdn: this.data().cdnName(),
      embed: this.data().embed() === 'true',
    };

    if (this.data().userIsPremier()) {
      globalData.user_type = 'premier';
    }

    if (this.data().isVideo()) {
      if (this.data().filmId() != 0) {
        globalData.film_id = this.data().filmId();
      }

      if (this.data().seasonId() != 0) {
        globalData.season_id = this.data().seasonId();
      }
    }
    PlayerAhoyEvent._globalAppendData = globalData;
  }

  displayAdLabel(width){
    displayLabel('.overlay-ad', width)
  }
}
